import { BehaviorSubject } from "rxjs";

export const APP_INFOS = { app_name: 'coop_finance_backoffice', app_commit_sha: '098e26f6db28', app_version: '2026.0525.1059' };
export const API_INFOS$ = new BehaviorSubject({ app_name: '', app_commit_sha: '098e26f6db28', app_version: '2026.0525.1059' });